/* eslint-disable react/no-danger */
/* eslint-disable jam3/no-sanitizer-with-danger */
import React, { ReactElement } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import { sanitizeHTML, useIsTouchOnlyDevice } from '@/lib/util';
import { ElementType } from '@/modules/types/element';
import { REACT_TOOLTIP_PREFIX, renderButtonTooltip } from './util';

interface FrameTooltipsPopoversProps {
  elements: ElementType[];
  isMobileView?: boolean;
}

interface FrameTooltipsBarProps {
  elements: ElementType[];
  tipBarRef?: React.RefObject<HTMLDivElement>;
}

interface FrameTooltipsProps
  extends FrameTooltipsPopoversProps,
    FrameTooltipsBarProps {}

export const FrameTooltipsPopovers = ({
  elements,
  isMobileView = false,
}: FrameTooltipsPopoversProps): ReactElement => {
  const isTouchOnly = useIsTouchOnlyDevice();
  const useClickToOpen = isMobileView || isTouchOnly;

  return (
    <>
      {elements.map((element: ElementType) => (
        <ReactTooltip
          id={`${REACT_TOOLTIP_PREFIX}-${element.elementMetadata.type}-${element.elementMetadata.position}`}
          float={!useClickToOpen}
          offset={10}
          key={`react-tooltip-${element.elementMetadata.position}`}
          className="ui-tooltip-content"
          openOnClick={useClickToOpen}
        >
          <div className="qtip-content">
            <div
              dangerouslySetInnerHTML={{
                __html: sanitizeHTML(element.content) as unknown as string,
              }}
              className="tooltip-container"
            />
          </div>
        </ReactTooltip>
      ))}
    </>
  );
};

export const FrameTooltipsBar = ({
  elements,
  tipBarRef,
}: FrameTooltipsBarProps): ReactElement | null => {
  if (elements.length === 0) return null;

  return (
    <div id="tip-bar" className="" style={{ display: 'block' }} ref={tipBarRef}>
      <div id="tips-holder">{renderButtonTooltip(elements)}</div>
    </div>
  );
};

const FrameTooltips = ({
  elements,
  isMobileView = false,
  tipBarRef,
}: FrameTooltipsProps): ReactElement => (
  <>
    <FrameTooltipsPopovers elements={elements} isMobileView={isMobileView} />
    <FrameTooltipsBar elements={elements} tipBarRef={tipBarRef} />
  </>
);

export default FrameTooltips;
